import { Component, Input, OnInit } from "@angular/core";
import { DataTypeModelKey } from "app/models/dataType.model";
import { ProjectDeviceModel } from "app/models/projectDevice.model";

@Component({
    selector: "app-device-status",
    templateUrl: "./device-status.component.html",
    styleUrls: ["./device-status.component.scss"],
    standalone: false,
})
export class DeviceStatusComponent implements OnInit {
    @Input() device: ProjectDeviceModel;
    DataTypeModelKey = DataTypeModelKey;

    constructor() {}

    ngOnInit() {}

    public hasSoundPressureLevel() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.soundPressureLevel) !== -1 : false;
    }

    public hasSoundPressureLevelC() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.soundPressureLevelC) !== -1 : false;
    }

    public hasSoundPressureLevel1Minute() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.soundPressureLevel1Minute) !== -1 : false;
    }

    public hasSoundPressureLevel1MinuteSensor2() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.soundPressureLevel1MinuteSensor2) !== -1 : false;
    }

    public hasSoundPressureLevelC1Minute() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.soundPressureLevelC1Minute) !== -1 : false;
    }

    public hasSoundPressureLevelCMinusA() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.soundPressureLevelCMinusA) !== -1 : false;
    }

    public hasRolling5() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.rolling5) !== -1 : false;
    }

    public hasRolling5C() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.rolling5C) !== -1 : false;
    }

    public hasRolling30() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.rolling30) !== -1 : false;
    }

    public hasRolling30C() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.rolling30C) !== -1 : false;
    }

    public hasRolling5s() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.rolling5s) !== -1 : false;
    }

    public hasRolling5sC() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.rolling5sC) !== -1 : false;
    }

    public hasBattery() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.battery) !== -1 : false;
    }

    public hasSpectrum() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.spectrum13Octave) !== -1 : false;
    }

    public hasSpectrum1Minute() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.spectrum13Octave1Minute) !== -1 : false;
    }

    public hasTemperature() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.temperature) !== -1 : false;
    }

    public hasCellular() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.cellullarSignalLevel) !== -1 : false;
    }

    public hasFreeStorage() {
        return this.device?.fields ? this.device.fields.indexOf(DataTypeModelKey.freeStorage) !== -1 : false;
    }
}
